import useCalendarActivityTypes from "./useCalendarActivityTypes";

export default useCalendarActivityTypes;
